import { Button, TextArea, Typography } from '@scale/scaleui';
import { useCallback, useMemo, useState } from 'react';
import SAlert from 'react-s-alert';
import { removeWorkerEntries } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';
import { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

export const ManuallyRemoveWorkers: React.FC = () => {
  const [workerIds, setWorkerIds] = useState<string>('');

  const [isUploading, setIsUploading] = useState<boolean>(false);

  const canUpload = useMemo(() => !isUploading && workerIds.length > 0, [workerIds, isUploading]);

  const handleSubmit = useCallback(async () => {
    setIsUploading(true);
    const workerIdsArray = workerIds.split(/[^a-zA-Z0-9]+/).filter(id => id.length > 0);
    try {
      const result = await removeWorkerEntries(workerIdsArray);
      if (result.success) {
        SAlert.success('Workers removed successfully');
        setWorkerIds('');
      } else {
        defaultApiFetchErrorHandler({ name: 'error', message: result.error, logError: () => null });
      }
    } finally {
      setIsUploading(false);
    }
  }, [workerIds]);

  return (
    <div className="flex flex-col gap-2">
      <Typography.Subtitle2>Manually Remove Workers</Typography.Subtitle2>
      <Typography.Paragraph2>
        Add a list of worker IDs to remove from the system.
      </Typography.Paragraph2>

      <TextArea
        id="worker-id-removal"
        value={workerIds}
        onChange={e => setWorkerIds(e.target.value)}
        style={{ height: 200 }}
      />
      <div>
        <Button disabled={!canUpload} onClick={handleSubmit}>
          Remove Workers
        </Button>
      </div>
    </div>
  );
};
